import React from 'react'
import ScrollToTop from './ScrollToTop'
import { Link } from 'react-router-dom'
import logo from './loader.png'
import Drustvene from './Drustvene'

const Footer = () => {
  return (

<div class="footer">
  <div class="logo-footer">
   <Link className="majice" to="/">
               <img src={logo} className="logo" alt="logo" height="250" />
      </Link>


  </div>
  <div class="cards">
    <p>Powered by: AutoFico.eu</p>
  </div>
</div>

  )
}

export default Footer

